import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/authContext";

const PublicRoute = ({ children }) => {
  const { isAuthenticated, isPending2FA } = useAuth();
  const location = useLocation();

  if (isAuthenticated && !isPending2FA) {
    // Redirect to the page they came from or dashboard
    return <Navigate to={location.state?.from?.pathname || "/dashboard"} replace />;
  }

  return children;
};

export default PublicRoute;